import React from "react";
import { ReactComponent as Calender } from "../../../asset/icons/calender_gray_s.svg";
import ex_img from "../../../asset/image/ex_img_3.png";
import { ReactComponent as Bookmark } from "../../../asset/icons/bookmark_white.svg";
import SmallCoin from "../../../asset/image/small-coin.png";
import { ReactComponent as Eye } from "../../../asset/icons/eye_white.svg";
import { ReactComponent as Like } from "../../../asset/icons/like_white.svg";
import { ReactComponent as Dislike } from "../../../asset/icons/dislike_white.svg";
import moment from "moment-jalaali";

moment.loadPersian();
export default function ProductCard({
    onClick,
    title,
    description,
    company,
    coin,
    date,
    like,
    dislike,
    view,
    image,
}) {
    const checkIfFileIsImage = () => {
        if (!image) return false;
        let arr = image.split(".");
        let ext = arr[arr.length - 1];
        const images = ["jpg", "jpeg", "png", "webp", "bmp", "gif"];
        if (images.includes(ext)) return true;
        return false;
    };

    return (
        <div className="customer-club-card-main" onClick={onClick}>
            <div className="customer-card-container">
                <div
                    className="card-header"
                    style={{
                        backgroundImage: `url(${
                            checkIfFileIsImage() ? image : ex_img
                        })`,
                    }}
                >
                    <div className="card-buttons">
                        <div className="coin-st">
                            <div>{coin}</div>
                            <img src={SmallCoin} alt="coin" />
                        </div>
                        <button className="sm-button">
                            <Bookmark />
                        </button>
                    </div>
                    <div className="logo-cv">
                        <div className="card-detail">
                            <div>
                                <div>
                                    <div>{dislike}</div>
                                </div>
                                <Dislike />
                            </div>
                            <div>
                                <div>
                                    <div>{like}</div>
                                </div>
                                <Like />
                            </div>
                            <div>
                                <div>
                                    <div>{view}</div>
                                </div>
                                <Eye />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-content">
                    <div className="comp-name">
                        {/* <div className="logo-con">
                        </div> */}
                        <div>{company}</div>
                    </div>
                    <h2>{title}</h2>
                    <p>{description?.substr(0, 100)}</p>
                    <div className="card-date">
                        <div>
                            <Calender />
                            <div>{moment(date).fromNow()}</div>
                        </div>
                        <div className="coin-st">
                            <div>{coin}</div>
                            <img src={SmallCoin} alt="coin" />
                        </div>
                        {/* <button className="sm-button"></button> */}
                    </div>
                </div>
            </div>
        </div>
    );
}
